import React from 'react';
import Footer from '../../components/Footer/Footer';
import SimpleHeader from '../../components/Header/simpleHeader';
import './AstoundUserNotFound.scss';
import failedIcon from '../../Assets/images/Activation/failed.svg';
import ButtonNew from '../../components/Button/Button';
import { useCookies } from 'react-cookie';

type initialProps = {
    history: any;
};

const AstoundUserNotFound = (props: initialProps) => {
    const [cookie, setCookie, removeCookie] = useCookies(['astoundAccessToken']);

    // Remove cookie
    // removeCookie('valueName');
    console.log(cookie);
    setCookie('astoundAccessToken', '');
    const handleLogout = () => {
        localStorage.clear();
        props.history.push('/mobile-login');

        // const { cookies } = this.props;
        removeCookie('astoundAccessToken');

        window.location.href = `${process.env.REACT_APP_ASTOUND_SSO_LOGOUT_URL}`;
    };
    return (
        <div className="astoundUserPage">
            <SimpleHeader history={props.history} isHelp={true} />

            <div className="userStatus">
                <img src={failedIcon} />
                <div className="userStatusTitle">Account Doesn’t Exist</div>
                <div className="userStatusSubtitle">
                    Sorry, there is no Astound Mobile account registered under this email address.
                </div>

                <div className="backToHome">
                    <ButtonNew primary={true} onClick={handleLogout}>
                        Log out
                    </ButtonNew>
                </div>
            </div>

            <Footer isFixed={true} />
        </div>
    );
};

export default AstoundUserNotFound;
